import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const DetailsPage = lazy(() => import('./details'));

export default {
    path: 'locations',
    children: [{
        path: ':locationId',
        Component: DetailsPage,
    }],
} satisfies RouteObject;
